export const AnalyticsActionType = Object.freeze({
    SET_USER_ACTIVITY_TIME: 'Analytics:: Set User Activity Time',
    SET_ALL_USERS_ACTIVITY_MINUTES: 'Analytics:: Set All Users Activity Minutes',
    SET_USER_LOGGED_IN_ACTIVITY: 'Analytics:: Set User Logged In Activity',
    SET_USER_DATA: 'Analytics:: Set User Data',
    SET_USER_ACTIVITY_ERROR: 'Analytics:: Set User Activity Error',
    
})